export default class Row {
  constructor (title, level = 0) {
    this.title = title
    this.level = level
  }
}
